module.exports = __webpack_public_path__ + "img/4.d6cb82a7.jpg";